var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAdminPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.874 7.17848L9.23812 11.4444C9.16343 11.5131 9.10348 11.5984 9.06238 11.6944C9.02128 11.7904 9 11.8948 9 12.0004C9 12.106 9.02128 12.2104 9.06238 12.3064C9.10348 12.4024 9.16343 12.4877 9.23812 12.5564L13.874 16.8223C14.3165 17.2294 15 16.8919 15 16.2663V7.73331C15 7.10768 14.3165 6.77015 13.874 7.17848Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAdminPrev);
export default __webpack_public_path__ + "static/media/ic_admin_prev.7a3557771d235a89cb0d4094f8246222.svg";
export { ForwardRef as ReactComponent };